import React, { useState, useEffect, useRef } from 'react';
import { Table } from 'react-bootstrap';
import ethLogo from '../../assets/images/eth-logo.svg';
import bscLogo from '../../assets/images/bsc-logo.svg';
import './NetworkScanner.css';

const NetworkScanner = () => {
  const allTrades = [
    {
      time: '10:30:45',
      pair: 'ETH/USDT',
      price: '3,245.67',
      dex: 'Uniswap V3',
      network: 'Ethereum',
      gas: '0.0021 ETH',
      opportunity: 'Found',
      networkLogo: ethLogo,
      txHash: '0x1234...5678'
    },
    {
      time: '10:30:42',
      pair: 'BNB/USDT',
      price: '312.45',
      dex: 'PancakeSwap',
      network: 'BSC',
      gas: '0.0005 BNB',
      opportunity: 'NotFound',
      networkLogo: bscLogo,
      txHash: '0xabcd...efgh'
    },
    {
      time: '10:30:40',
      pair: 'ETH/USDT',
      price: '3,245.12',
      dex: 'SushiSwap',
      network: 'Ethereum',
      gas: '0.0023 ETH',
      opportunity: 'Found',
      networkLogo: ethLogo,
      txHash: '0x9876...5432'
    },
    {
      time: '10:30:38',
      pair: 'BNB/USDT',
      price: '312.48',
      dex: 'PancakeSwap',
      network: 'BSC',
      gas: '0.0006 BNB',
      opportunity: 'NotFound',
      networkLogo: bscLogo,
      txHash: '0xwxyz...uvwx'
    },
    {
      time: '10:30:35',
      pair: 'ETH/USDT',
      price: '3,245.89',
      dex: 'Uniswap V3',
      network: 'Ethereum',
      gas: '0.0022 ETH',
      opportunity: 'Found',
      networkLogo: ethLogo,
      txHash: '0xmnop...qrst'
    },
    {
      time: '10:30:32',
      pair: 'BNB/USDT',
      price: '312.42',
      dex: 'PancakeSwap',
      network: 'BSC',
      gas: '0.0005 BNB',
      opportunity: 'NotFound',
      networkLogo: bscLogo,
      txHash: '0xijkl...mnop'
    },
    {
      time: '10:30:30',
      pair: 'ETH/USDT',
      price: '3,245.45',
      dex: 'SushiSwap',
      network: 'Ethereum',
      gas: '0.0021 ETH',
      opportunity: 'Found',
      networkLogo: ethLogo,
      txHash: '0xefgh...ijkl'
    },
    {
      time: '10:30:28',
      pair: 'BNB/USDT',
      price: '312.46',
      dex: 'PancakeSwap',
      network: 'BSC',
      gas: '0.0005 BNB',
      opportunity: 'NotFound',
      networkLogo: bscLogo,
      txHash: '0xabcd...efgh'
    },
    {
      time: '10:30:25',
      pair: 'ETH/USDT',
      price: '3,245.78',
      dex: 'Uniswap V3',
      network: 'Ethereum',
      gas: '0.0022 ETH',
      opportunity: 'Found',
      networkLogo: ethLogo,
      txHash: '0x1234...5678'
    },
    {
      time: '10:30:22',
      pair: 'BNB/USDT',
      price: '312.44',
      dex: 'PancakeSwap',
      network: 'BSC',
      gas: '0.0005 BNB',
      opportunity: 'NotFound',
      networkLogo: bscLogo,
      txHash: '0x9876...5432'
    }
  ];

  const [allTradesHistory, setAllTradesHistory] = useState(allTrades);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoScrolling, setIsAutoScrolling] = useState(true);
  const tableRef = useRef(null);

  // Handle scroll events
  const handleScroll = () => {
    if (tableRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = tableRef.current;
      const isAtBottom = scrollHeight - scrollTop === clientHeight;
      setIsAutoScrolling(isAtBottom);
    }
  };

  const handleTxHashClick = (txHash, network) => {
    // You can implement the logic to open the transaction in a block explorer
    const explorerUrl = network === 'Ethereum' 
      ? `https://etherscan.io/tx/${txHash}`
      : `https://bscscan.com/tx/${txHash}`;
    window.open(explorerUrl, '_blank');
  };

  useEffect(() => {
    const interval = setInterval(() => {
      // Update the current time for all trades
      const updatedTrades = allTradesHistory.map(trade => {
        const [hours, minutes, seconds] = trade.time.split(':');
        const newSeconds = (parseInt(seconds) + 1) % 60;
        const newMinutes = newSeconds === 0 ? (parseInt(minutes) + 1) % 60 : parseInt(minutes);
        const newHours = newMinutes === 0 && newSeconds === 0 ? (parseInt(hours) + 1) % 24 : parseInt(hours);
        
        return {
          ...trade,
          time: `${String(newHours).padStart(2, '0')}:${String(newMinutes).padStart(2, '0')}:${String(newSeconds).padStart(2, '0')}`
        };
      });

      // Append new trade
      const newTrade = {
        ...allTrades[currentIndex],
        time: new Date().toLocaleTimeString('en-US', { hour12: false })
      };
      
      setAllTradesHistory([...updatedTrades, newTrade]);
      setCurrentIndex((prevIndex) => (prevIndex + 1) % allTrades.length);

      // Auto-scroll to bottom only if user hasn't scrolled up
      if (isAutoScrolling && tableRef.current) {
        tableRef.current.scrollTop = tableRef.current.scrollHeight;
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [allTradesHistory, currentIndex, isAutoScrolling]);

  // Get the last 10 trades for display
  const displayTrades = allTradesHistory.slice(-10);

  return (
    <div className="network-scanner-container">
      {/* <h2 className="network-scanner-title">Network Scanner</h2> */}
      <div 
        className="network-scanner-table-container" 
        ref={tableRef}
        onScroll={handleScroll}
      >
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Time</th>
              <th>Pair</th>
              <th>Price</th>
              <th>DEX</th>
              <th>Network</th>
              <th>Gas</th>
              <th>Transaction</th>
              <th>Opportunity</th>
            </tr>
          </thead>
          <tbody>
            {displayTrades.map((trade, index) => (
              <tr key={index}>
                <td>{trade.time}</td>
                <td>{trade.pair}</td>
                <td>{trade.price}</td>
                <td>{trade.dex}</td>
                <td>
                  <div className="network-cell">
                    <img src={trade.networkLogo} alt={trade.network} className="network-logo" />
                    {trade.network}
                  </div>
                </td>
                <td>{trade.gas}</td>
                <td>
                  <span 
                    className="tx-hash"
                    onClick={() => handleTxHashClick(trade.txHash, trade.network)}
                  >
                    {trade.txHash}
                  </span>
                </td>
                <td>
                  <span className={`opportunity-badge ${trade.opportunity.toLowerCase()}`}>
                    {trade.opportunity === 'Found' ? 'Opportunity Found' : 'No Opportunity Found'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default NetworkScanner; 